const getSortable = () => import('sortablejs')

angular
  .module('deskfy.arts')
  .controller('ArtsPageCustomizationController', ArtsPageCustomizationController)

/* @ngInject */
function ArtsPageCustomizationController ($scope, $q, $rootScope, $state, $timeout, $translate, ArtsService, ToastService, ModalService, SegmentService, ArtCollectionsService, TemplateService, UdsModalService, CustomerConfigurationsService, ConfirmationModalService) {
  const getCreateCampaignDialogController = () => $q.when(import('../../../admin/dialogs/create-campaign/create-campaign-dialog.controller'))
  const getDeleteSectionDialogController = () => $q.when(import('../../dialogs/delete-section/delete-section-dialog.controller'))
  const getArtSizeDialogController = () => $q.when(import('../../dialogs/art-size/art-size-dialog.controller'))

  $scope.sectionTop = 5
  $scope.sectionIndex = 0
  $scope.filesTop = 10
  $scope.highlightedTop = 10
  $scope.highlightedIndex = 0
  $scope.loading = true
  $scope.sections = []
  $scope.updates = []
  $scope.location = 'materials'
  $scope.companyFeatures = {
    artsCustomization: {
      access: true
    }
  }

  $scope.templateOptions = {
    edit: true,
    move: true,
    download: true,
    archive: true,
    share: true,
    settings: true
  }

  $scope.materialsOrder = 'ASC'
  $scope.materialsSort = 'manual'
  $scope.materialsSortOptions = [
    {
      label: $translate.instant('manualOnly'),
      value: 'manual'
    },
    {
      label: $translate.instant('name'),
      value: 'name'
    },
    {
      label: $translate.instant('recents'),
      value: 'recents'
    }
  ]
  let adminView = false

  const api = {
    getCreateCampaignDialogController,
    getDeleteSectionDialogController,
    getArtSizeDialogController,
    _getArtSections,
    _handleCompanyFeatures,
    _getSectionCollections,
    _getSectionTemplates,
    _getHighlightedCollections,
    _activateHighlightedSortable,
    _activateCollectionsSortable,
    _activateTemplatesSortable,
    _onUpdate,
    _successUpdateOrder,
    _changeItemsOrder,
    _changeHighlightedOrder,
    _createIntersectionObserver,
    _scrollToHighlightedCollections,
    _getIndexCurrentOfSectionsArrayById,
    _updateDataIndividually,
    _getMaterialsSortAndOrderConfigurations,
    _onSuccessChangeMaterialsSortOrder
  }

  this.getApi = () => api

  activate()

  function activate () {
    SegmentService
      .track('arts-templateedit-view')
    api._getMaterialsSortAndOrderConfigurations()
    api._getArtSections({ allCollections: true, top: $scope.sectionTop, skip: 0 }, true)

    $rootScope.getUser()
      .then(() => {
        adminView = $rootScope.isUserSysAdminAdminDesigner()
        api._getHighlightedCollections({ top: $scope.highlightedTop, skip: 0 }, true)
      })

    api._createIntersectionObserver()
    api._handleCompanyFeatures()
  }

  $scope.onChangeMaterialsOrder = () => {
    ConfirmationModalService.createModal({
      description: $translate.instant('materialsOrdenation.confirmDialog.description'),
      buttonCancelText: $translate.instant('cancel'),
      buttonConfirmText: $translate.instant('materialsOrdenation.confirmDialog.buttonConfirmText'),
      onConfirm: () => {
        $scope.materialsOrder = $scope.materialsOrder === 'ASC' ? 'DESC' : 'ASC'

        if ($scope.materialsSort === 'manual') {
          $scope.materialsOrder = 'ASC'
        }

        CustomerConfigurationsService.updateStringConfiguration({
          config: 'MATERIALS_COLLECTIONS_ORDER',
          value: $scope.materialsOrder
        })
          .then(api._onSuccessChangeMaterialsSortOrder)
          .catch(() => {
            ToastService.showErrorToast($translate.instant('materialsOrdenation.toasts.error'))
          })
      }
    })
  }

  $scope.onChangeMaterialsSort = (event) => {
    const previousSortValue = $scope.materialsSort
    const previousSortOptions = [...$scope.materialsSortOptions]
    const previousSelectedOption = $scope.selectedSortOption

    ConfirmationModalService.createModal({
      description: $translate.instant('materialsOrdenation.confirmDialog.description'),
      buttonCancelText: $translate.instant('cancel'),
      buttonConfirmText: $translate.instant('materialsOrdenation.confirmDialog.buttonConfirmText'),
      onConfirm: () => {
        const value = event?.detail?.value

        if (value) {
          $scope.materialsSort = value

          $scope.materialsSortOptions = [
            {
              label: $translate.instant('manualOnly'),
              value: 'manual',
              active: value === 'manual'
            },
            {
              label: $translate.instant('name'),
              value: 'name',
              active: value === 'name'
            },
            {
              label: $translate.instant('recents'),
              value: 'recents',
              active: value === 'recents'
            }
          ]

          $scope.selectedSortOption = $scope.materialsSortOptions.find(option => option.active)

          if ($scope.materialsSort === 'manual') {
            $scope.materialsOrder = 'ASC'

            CustomerConfigurationsService.updateStringConfiguration({
              config: 'MATERIALS_COLLECTIONS_ORDER',
              value: $scope.materialsOrder
            })
          }

          CustomerConfigurationsService.updateStringConfiguration({
            config: 'MATERIALS_COLLECTIONS_SORT',
            value: $scope.materialsSort
          })
            .then(api._onSuccessChangeMaterialsSortOrder)
            .catch(() => {
              ToastService.defaultErrorToast($translate.instant('materialsOrdenation.toasts.error'))
            })
        }
      },
      onCancel: () => {
        $scope.materialsSortOptions = []
        $scope.selectedSortOption = null

        $timeout(() => {
          $scope.materialsSort = previousSortValue
          $scope.materialsSortOptions = previousSortOptions
          $scope.selectedSortOption = previousSelectedOption

          if (!$scope.$$phase) {
            $scope.$apply()
          }
        }, 0)
      }
    })
  }

  function _updateDataIndividually (updateTargets, callback) {
    const dataTypes = {
      collections: (index, id) => {
        ArtCollectionsService.getCollectionsById(id, { top: 10, skip: 0 }).then(collections => {
          const currentSection = { ...$scope.sections[index] }
          $scope.sections[index] = {
            ...currentSection,
            isExpanded: true,
            filesCount: parseInt(currentSection?.templates?.length || 0 + collections.count),
            collectionsCount: collections.count,
            collections: collections.rows
          }
        })
      },
      templates: (index, id) => {
        ArtCollectionsService.getTemplatesById(id, { top: 10, skip: 0 }).then(templates => {
          const currentSection = { ...$scope.sections[index] }
          $scope.sections[index] = {
            ...currentSection,
            isExpanded: true,
            filesCount: parseInt(currentSection?.collections?.length || 0 + templates.count),
            countTemplates: templates.count,
            templates: templates.rows
          }
        })
      }
    }

    updateTargets.forEach(target => {
      const updateFunction = dataTypes?.[target.dataType]
      if (updateFunction) {
        updateFunction(target.index, target.id)
      }
    })

    if (callback) {
      callback()
    }
  }

  const deregisterReloadArtsPage = $scope.$on('reload-arts-page', (ev, args) => {
    const actions = {
      default: () => activate(),
      highlightCollection: () => {
        const sectionId = args?.old?.sectionId

        if (sectionId) {
          const arrayIndexFoUpdate = api._getIndexCurrentOfSectionsArrayById($scope.sections, sectionId)
          const updates = [{ index: arrayIndexFoUpdate, id: sectionId, dataType: 'collections' }]
          api._updateDataIndividually(updates)
        }

        api._getHighlightedCollections({ top: $scope.highlightedTop, skip: 0 }, true)
        api._scrollToHighlightedCollections()
      },
      updateTemplate: () => {
        api._updateDataIndividually($scope.updates, () => {
          $scope.updates = []
        })
      },
      archiveCollection: () => {
        const sectionId = args?.sectionId

        if (args?.highlighted) {
          api._getHighlightedCollections({ top: $scope.highlightedTop, skip: 0 }, true)
          api._scrollToHighlightedCollections()
          return
        }

        if (sectionId) {
          const arrayIndexFoUpdate = api._getIndexCurrentOfSectionsArrayById($scope.sections, sectionId)
          const updates = [{ index: arrayIndexFoUpdate, id: sectionId, dataType: 'collections' }]

          api._updateDataIndividually(updates)
        }
      },
      archiveTemplate: () => {
        const sectionId = args?.sectionId

        if (sectionId) {
          const arrayIndexFoUpdate = api._getIndexCurrentOfSectionsArrayById($scope.sections, sectionId)
          const updates = [{ index: arrayIndexFoUpdate, id: sectionId, dataType: 'templates' }]

          api._updateDataIndividually(updates)
        }
      },
      moveTemplate: () => {
        const sourceSectionId = args?.in
        const whitherSectionId = args?.to
        if (sourceSectionId) {
          const arrayIndexFoUpdate = api._getIndexCurrentOfSectionsArrayById($scope.sections, sourceSectionId)
          const updates = [
            { index: arrayIndexFoUpdate, id: sourceSectionId, dataType: 'collections' },
            { index: arrayIndexFoUpdate, id: sourceSectionId, dataType: 'templates' }
          ]
          api._updateDataIndividually(updates)
        }
        if (whitherSectionId) {
          const arrayIndexFoUpdate = api._getIndexCurrentOfSectionsArrayById($scope.sections, whitherSectionId)
          const updates = [
            { index: arrayIndexFoUpdate, id: whitherSectionId, dataType: 'collections' },
            { index: arrayIndexFoUpdate, id: whitherSectionId, dataType: 'templates' }
          ]
          api._updateDataIndividually(updates)
        }
      },
      moveCollection: () => {
        const sourceSectionId = args?.in
        const whitherSectionId = args?.to
        if (sourceSectionId) {
          const arrayIndexFoUpdate = api._getIndexCurrentOfSectionsArrayById($scope.sections, sourceSectionId)
          const updates = [{ index: arrayIndexFoUpdate, id: sourceSectionId, dataType: 'collections' }]
          api._updateDataIndividually(updates)
        }
        if (whitherSectionId) {
          const arrayIndexFoUpdate = api._getIndexCurrentOfSectionsArrayById($scope.sections, whitherSectionId)
          const updates = [{ index: arrayIndexFoUpdate, id: whitherSectionId, dataType: 'collections' }]
          api._updateDataIndividually(updates)
        }
      }
    }

    const actionCalled = actions?.[args?.emitter] || actions.default
    actionCalled()
  })

  $scope.$on('$destroy', () => {
    const container = $('.content-container-two-menu.dashboard')
    container.off('scroll')

    deregisterReloadArtsPage()
  })

  $scope.onLastSectionLoad = function () {
    $timeout(() => {
      $('.add-dropdown').dropdown()
    }, 3000, false)
  }

  $scope.exitEditMode = function () {
    $state.go('arts.templates')
  }

  $scope.cancelSectionNewTitle = function (section) {
    section.newTitle = section.title
  }

  $scope.changeIsExpanded = function (group) {
    group.isExpanded = !group.isExpanded
  }

  $scope.saveNewSectionTitle = function (section) {
    if (section.id && section.newTitle && section.title !== section.newTitle) {
      section.loading = true
      ArtsService.updateArtSection(section.id, { title: section.newTitle }).then(() => {
        section.title = section.newTitle
      }).catch(ToastService.defaultErrorToast).finally(() => {
        section.loading = false
        SegmentService
          .track('arts-section-usage', { action: 'edit' })
      })
    }
  }

  $scope.createSectionClick = function (section) {
    const newSection = {
      id: null,
      title: $translate.instant('materials'),
      order: null,
      isArchived: false,
      isExpanded: true,
      products: {
        count: 0,
        rows: []
      },
      index: 0
    }

    const newArray = []

    let currentIndex = null

    if (section) {
      newSection.order = section.order
      currentIndex = $scope.sections.findIndex(item => item.id === section.id)

      if (currentIndex >= 1) {
        for (let i = 0; i < currentIndex; i++) {
          newArray.push($scope.sections[i])
        }
      }

      for (let i = currentIndex; i < $scope.sections.length; i++) {
        if (currentIndex === i) {
          newArray.push(newSection)
        }
        $scope.sections[i].order++
        newArray.push($scope.sections[i])
      }

      $scope.sections = newArray
    } else {
      newSection.order = $scope.sections.length
      $scope.sections.push(newSection)
    }

    ArtCollectionsService.createArtSection({ title: $translate.instant('materials'), order: newSection.order }).then(createdSection => {
      if (currentIndex !== null) {
        $scope.sections[currentIndex].id = createdSection.id
      } else {
        $scope.sections[$scope.sections.length - 1].id = createdSection.id
      }

      $scope.sectionsCount++
    }).catch(ToastService.defaultErrorToast).then(() => {
      SegmentService
        .track('arts-section-usage', { action: 'add' })
    })
  }

  $scope.nextSectionPage = function () {
    $scope.sectionIndex += 1

    api._getArtSections({ allCollections: true, top: $scope.sectionTop, skip: $scope.sectionTop * $scope.sectionIndex })
  }

  $scope.loadMoreFiles = function (section) {
    section.index++
    section.loading = true
    api._getSectionCollections(section, section.index)
    api._getSectionTemplates(section, section.index)

    $timeout(() => {
      section.loading = false
    }, 1000)
  }

  $scope.onImgLoadError = function () {
    return '/assets/img/icons/img-placeholder.png'
  }

  $scope.addTemplateClick = function (artCollectionId) {
    api.getArtSizeDialogController().then(({ ArtSizeDialogController }) => {
      const artSizeDialog = UdsModalService.createModal({
        controller: ArtSizeDialogController,
        modalName: 'artSizeDialog',
        data: {
          artCollectionId
        },
        onClose: () => {
          const arrayIndexFoUpdate = api._getIndexCurrentOfSectionsArrayById($scope.sections, artCollectionId)
          $scope.updates = [{ index: arrayIndexFoUpdate, id: artCollectionId, dataType: 'templates' }]
        }
      })

      artSizeDialog.open()
    })
  }

  $scope.addCollectionClick = function (artCollectionId) {
    api.getCreateCampaignDialogController().then(({ CreateCampaignDialogController }) => {
      ModalService.showModal({
        templateId: 'createCampaign.html',
        templateUrl: '/admin/dialogs/create-campaign/create-campaign-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: CreateCampaignDialogController,
        data: {
          artCollectionId,
          showHightlightOption: true
        }
      }).then(changed => {
        if (changed) {
          const arrayIndexFoUpdate = api._getIndexCurrentOfSectionsArrayById($scope.sections, artCollectionId)
          const updates = [{ index: arrayIndexFoUpdate, id: artCollectionId, dataType: 'collections' }]
          api._updateDataIndividually(updates)
        }
      })
    })
  }

  $scope.moveUp = function (section) {
    if ($scope.sectionLoading) {
      return
    }
    const sectionList = [...$scope.sections]
    const currentIndex = api._getIndexCurrentOfSectionsArrayById(sectionList, section.id)
    const newIndex = currentIndex - 1

    if (currentIndex > 0) {
      const current = sectionList[currentIndex]
      const prev = sectionList[newIndex]

      const updatedSection = { ...current, order: newIndex }
      sectionList.splice(currentIndex, 1)
      sectionList.splice(newIndex, 0, updatedSection)

      $scope.sectionLoading = true

      ArtsService.updateArtSection(current.id, { order: updatedSection.order })
        .finally(() => {
          $scope.sectionLoading = false
          SegmentService
            .track('arts-section-usage', { action: 'order' })
        })
        .catch(ToastService.defaultErrorToast)
        .then(() => {
          if (prev) {
            prev.order = current.order
          }
          $scope.sections = sectionList
        })
    }
  }

  $scope.moveDown = function (section) {
    if ($scope.sectionLoading) {
      return
    }
    if ($scope.sections.length - 1 > section.order) {
      const sectionList = [...$scope.sections]
      const currentIndex = api._getIndexCurrentOfSectionsArrayById(sectionList, section.id)
      const newIndex = currentIndex + 1

      const current = sectionList[currentIndex]
      const next = sectionList[newIndex]

      if (currentIndex < sectionList.length - 1) {
        const updatedSection = { ...current, order: newIndex }
        sectionList.splice(currentIndex, 1)
        sectionList.splice(newIndex, 0, updatedSection)

        $scope.sectionLoading = true

        ArtsService
          .updateArtSection(current.id, { order: updatedSection.order })
          .finally(() => {
            $scope.sectionLoading = false
            SegmentService
              .track('arts-section-usage', { action: 'order' })
          })
          .catch(ToastService.defaultErrorToast)
          .then(() => {
            if (next) {
              next.order = current.order
            }
            $scope.sections = sectionList
          })
      }
    }
  }

  $scope.deleteSection = function (section) {
    getDeleteSectionDialogController().then(({ DeleteSectionDialogController }) => {
      const deleteSectionDialog = UdsModalService.createModal({
        controller: DeleteSectionDialogController,
        modalName: 'deleteSectionDialog',
        data: {
          section: section
        },
        onClose: (modalReturn) => {
          if (modalReturn?.section) {
            const index = $scope.sections.findIndex(item => item.id === modalReturn.section.id)
            $scope.sections.splice(index, 1)
            SegmentService.track('arts-section-usage', { action: 'archive' })
          }
        }
      })

      deleteSectionDialog.open()
    })
  }

  $scope.onChangeTitle = function (event, section) {
    if (event.charCode === 13) {
      $scope.saveNewSectionTitle(section)
    }
  }

  $scope.goToCampaigns = function () {
    $state.go('admin.campaigns')
  }

  $scope.loadMoreHighlightedCollections = function () {
    $scope.highlightedIndex++
    api._getHighlightedCollections({ top: $scope.highlightedTop, skip: $scope.highlightedTop * $scope.highlightedIndex })
  }

  $scope.navegateToSettings = function () {
    $state.go('admin.campaigns')
  }

  function _getArtSections (params, reset) {
    if (reset) {
      $scope.sections = []
      $scope.sectionsCount = 0
      $scope.sectionIndex = 0
    }

    $scope.loading = true
    ArtCollectionsService.getArtSections(params).then(sections => {
      const newSections = sections.rows.map(row => {
        row.order = parseInt(row.order, 10)
        row.newTitle = row.title
        row.index = 0
        return row
      })

      $scope.sections.push(...newSections)
      $scope.sectionsCount = sections.count

      newSections.forEach(section => {
        section.isExpanded = true
        section.filesCount = 0
        api._getSectionCollections(section, 0, true)
        api._getSectionTemplates(section, 0, true)
      })
    })

    $timeout(() => {
      $scope.$apply(() => {
        $scope.sectionLoading = false
        $scope.loading = false
      })
    }, 2000, false)
  }

  function _getSectionCollections (section, index, firstLoad) {
    if (firstLoad) {
      section.collections = []
    }

    ArtCollectionsService.getCollectionsById(section.id, { top: $scope.filesTop, skip: $scope.filesTop * index }).then(collections => {
      section.collections.push(...collections.rows)

      if (collections.count) {
        $scope.areThereTemplates = true
      }

      if (firstLoad) {
        section.filesCount += parseInt(collections.count)
      }

      if ($scope.materialsSort === 'manual') {
        api._activateCollectionsSortable(section.id)
      }
    })
  }

  function _getSectionTemplates (section, index, firstLoad) {
    if (firstLoad) {
      section.templates = []
    }

    ArtCollectionsService.getTemplatesById(section.id, { top: $scope.filesTop, skip: $scope.filesTop * index }).then(templates => {
      section.templates.push(...templates.rows)

      if (templates.count) {
        $scope.areThereTemplates = true
      }

      if (firstLoad) {
        section.filesCount += parseInt(templates.count)
      }

      if ($scope.materialsSort === 'manual') {
        api._activateTemplatesSortable(section.id)
      }
    })
  }

  function _getHighlightedCollections (params, reset) {
    if (adminView) {
      params.adminView = adminView
    }

    if (reset) {
      $scope.highlightedCollections = []
      $scope.highlightedIndex = 0
    }

    ArtCollectionsService.getHighlightedCollections(params).then(res => {
      $scope.highlightedCollections.push(...res.rows)
      $scope.highlightedCollectionsCount = res.count

      api._activateHighlightedSortable()
    })
  }

  function _activateHighlightedSortable () {
    getSortable().then(({ Sortable }) => {
      $timeout(() => {
        const sortableList = document.getElementById('highlighted-collections-list')
        Sortable.create(sortableList, {
          group: 'highlighted',
          sort: true,
          animation: 150, // time of animation
          ghostClass: 'collection-ghost', // class name for the drop placeholder
          onUpdate: api._onUpdate
        })
      }, 1000, false)
    })
  }

  function _activateCollectionsSortable (sectionId) {
    const sectionElement = document.getElementById(`section-content-${sectionId}`)

    let sortableList = null

    if (sectionElement) {
      sortableList = sectionElement.getElementsByClassName('section-content-collections')

      if (sortableList) {
        sortableList = Array.from(sortableList)
        sortableList = sortableList[0]
      }
    }

    if (sortableList) {
      getSortable().then(({ Sortable }) => {
        $timeout(() => {
          Sortable.create(sortableList, {
            group: `collections-${sectionId}`,
            sort: true,
            animation: 150, // time of animation
            ghostClass: 'collection-ghost', // class name for the drop placeholder
            onUpdate: api._onUpdate
          })
        }, 1000, false)
      })
    }
  }

  function _activateTemplatesSortable (sectionId) {
    const sectionElement = document.getElementById(`section-content-${sectionId}`)

    let sortableList = null

    if (sectionElement) {
      sortableList = sectionElement.getElementsByClassName('section-content-templates')

      if (sortableList) {
        sortableList = Array.from(sortableList)
        sortableList = sortableList[0]
      }
    }

    if (sortableList) {
      getSortable().then(({ Sortable }) => {
        $timeout(() => {
          Sortable.create(sortableList, {
            group: `templates-${sectionId}`,
            sort: true,
            animation: 150, // time of animation
            ghostClass: 'templates-ghost', // class name for the drop placeholder
            onUpdate: api._onUpdate
          })
        }, 1000, false)
      })
    }
  }

  function _onUpdate (e) {
    const oldIndex = e.oldIndex
    const newIndex = e.newIndex
    const item = e.item.id // id of element that was moved
    const from = e.from.id // id of div where the element is from
    const isTemplate = item.includes('template-item')
    const itemId = item.replace(/\D/g, '')
    const fromId = from.replace(/\D/g, '') // section id

    if (fromId) {
      $scope.loadingOrder = true
      api._changeItemsOrder(isTemplate, fromId, itemId, newIndex, oldIndex) // change order on frontend
    } else {
      $scope.loadingHighlighted = true
      api._changeHighlightedOrder(itemId, newIndex, oldIndex) // change order on frontend
    }

    if (!$scope.$$phase) {
      $scope.$apply()
    }

    if (isTemplate) {
      SegmentService.track('arts-template-order', { place: 'Section' })
      TemplateService.changeTemplateOrder(itemId, newIndex).then(api._successUpdateOrder) // change order on backend
    } else {
      if (fromId) {
        SegmentService.track('arts-collection-order', { place: 'Section' })
      } else {
        SegmentService.track('arts-collection-order', { place: 'Highlight' })
      }
      ArtCollectionsService.updateItemOrder(itemId, newIndex).then(api._successUpdateOrder) // change order on backend
    }
  }

  function _changeItemsOrder (isTemplate, sectionId, itemId, newIndex, oldIndex) {
    const section = $scope.sections.find(item => item.id === parseInt(sectionId))
    if (isTemplate) {
      let template = null
      if (section) {
        template = section.templates.find(item => item.id === parseInt(itemId))
      }

      if (template) {
        template.order = newIndex
      }

      if (newIndex > oldIndex) {
        for (let i = 0; i < section.templates.length; i++) {
          if (section.templates[i].id !== parseInt(itemId)) {
            if (section.templates[i].order <= newIndex && section.templates[i].order >= oldIndex) {
              section.templates[i].order--
            }
          }
        }
      } else {
        for (let i = 0; i < section.templates.length; i++) {
          if (section.templates[i].id !== parseInt(itemId)) {
            if (section.templates[i].order >= newIndex && section.templates[i].order <= oldIndex) {
              section.templates[i].order++
            }
          }
        }
      }
    } else {
      let collection = null
      if (section) {
        collection = section.collections.find(item => item.id === parseInt(itemId))
      }

      if (collection) {
        collection.order = newIndex
      }

      if (newIndex > oldIndex) {
        for (let i = 0; i < section.collections.length; i++) {
          if (section.collections[i].id !== parseInt(itemId)) {
            if (section.collections[i].order <= newIndex && section.collections[i].order >= oldIndex) {
              section.collections[i].order--
            }
          }
        }
      } else {
        for (let i = 0; i < section.collections.length; i++) {
          if (section.collections[i].id !== parseInt(itemId)) {
            if (section.collections[i].order >= newIndex && section.collections[i].order <= oldIndex) {
              section.collections[i].order++
            }
          }
        }
      }
    }
  }

  function _changeHighlightedOrder (itemId, newIndex, oldIndex) {
    const collection = $scope.highlightedCollections.find(item => item.id === parseInt(itemId))

    if (collection) {
      collection.order = newIndex
    }

    if (newIndex > oldIndex) {
      for (let i = 0; i < $scope.highlightedCollections.length; i++) {
        if ($scope.highlightedCollections[i].id !== parseInt(itemId)) {
          if ($scope.highlightedCollections[i].order <= newIndex && $scope.highlightedCollections[i].order >= oldIndex) {
            $scope.highlightedCollections[i].order--
          }
        }
      }
    } else {
      for (let i = 0; i < $scope.highlightedCollections.length; i++) {
        if ($scope.highlightedCollections[i].id !== parseInt(itemId)) {
          if ($scope.highlightedCollections[i].order >= newIndex && $scope.highlightedCollections[i].order <= oldIndex) {
            $scope.highlightedCollections[i].order++
          }
        }
      }
    }
  }

  function _successUpdateOrder () {
    $timeout(() => {
      $scope.$apply(() => {
        $scope.loadingHighlighted = false
        $scope.loadingOrder = false
      })
    }, 500, false)
  }

  function _createIntersectionObserver () {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        if (!$scope.loading && $scope.sectionsCount > $scope.sections.length) {
          $scope.nextSectionPage()
        }
      }
    })

    const sentinel = $('#sentinel')[0]

    if (sentinel) {
      observer.observe(sentinel)
    }
  }

  function _getIndexCurrentOfSectionsArrayById (arrayOfSections, id) {
    return arrayOfSections.findIndex(item => item.id === id)
  }

  function _scrollToHighlightedCollections () {
    document.querySelector('#highlighted-collections-list').scrollIntoView({
      block: 'end',
      inline: 'end',
      behavior: 'smooth'
    })
  }

  function _handleCompanyFeatures () {
    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      const customizableArtsSlug = String('ARTS.CUSTOMIZABLE_ARTS')
      $scope.companyFeatures.artsCustomization.access = !!features[customizableArtsSlug]
    })
  }

  function _getMaterialsSortAndOrderConfigurations () {
    CustomerConfigurationsService.getOneConfigurationByType('MATERIALS_COLLECTIONS_SORT', 'STRING')
      .then((sortConfig) => {
        if (sortConfig?.value) {
          $scope.materialsSort = sortConfig.value

          $scope.materialsSortOptions = [
            {
              label: $translate.instant('manualOnly'),
              value: 'manual',
              active: $scope.materialsSort === 'manual'
            },
            {
              label: $translate.instant('name'),
              value: 'name',
              active: $scope.materialsSort === 'name'
            },
            {
              label: $translate.instant('recents'),
              value: 'recents',
              active: $scope.materialsSort === 'recents'
            }
          ]

          $scope.selectedSortOption = $scope.materialsSortOptions.find(option => option.active)
        }
      })

    CustomerConfigurationsService.getOneConfigurationByType('MATERIALS_COLLECTIONS_ORDER', 'STRING')
      .then((orderConfig) => {
        if (orderConfig?.value) {
          $scope.materialsOrder = orderConfig.value
        }
      })
  }

  function _onSuccessChangeMaterialsSortOrder () {
    ToastService.showSuccessToast($translate.instant('materialsOrdenation.toasts.success'))

    api._getArtSections({ allCollections: true, top: $scope.sectionTop, skip: 0 }, true)
    api._getHighlightedCollections({ top: $scope.highlightedTop, skip: 0 }, true)
  }
}
